import { faBolt, faCoins } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ACCENT, Panel } from '~/components/ui'
import { useCashier } from '~/features/bank/hooks/useCashier'

/**
 * Shown when a spin fails because the player is short on funds. Rather than a
 * dead error, it names the amount they need and drops them one tap from the
 * cashier's deposit tab.
 */
export const InsufficientFundsModal = ({ amount, currency }: { amount: string; currency: string }) => {
    const { open } = useCashier()

    return (
        <Panel border={ACCENT} className='flex flex-col items-center gap-6 px-6 py-9 text-center sm:px-10'>
            <div className='grid h-16 w-16 place-items-center rounded-full border border-[#03CEFF]/40 bg-[#03CEFF]/10 text-2xl text-[#03CEFF]'>
                <FontAwesomeIcon icon={faCoins} />
            </div>

            <div className='flex flex-col gap-2'>
                <h2 className='font-monument text-2xl font-black uppercase leading-none tracking-[0.05em]'>
                    Not enough funds
                </h2>
                <p className='max-w-xs text-sm font-medium leading-relaxed text-white/55'>
                    You need{' '}
                    <span className='font-black text-white'>
                        {amount} {currency}
                    </span>{' '}
                    to open this pack. Top up now and you&apos;re one tap from ripping.
                </p>
            </div>

            {/* The deposit CTA: big, gradient, and glowing so it's the obvious
                next move. */}
            <button
                onClick={() => open('deposit')}
                style={{ background: ACCENT, boxShadow: '0 0 32px rgba(3,206,255,0.45)' }}
                className='flex w-full min-h-[3.5rem] items-center justify-center gap-2.5 px-8 text-base font-black uppercase tracking-[0.18em] transition-[filter,transform] hover:scale-[1.02] hover:brightness-110'
            >
                <FontAwesomeIcon icon={faBolt} />
                Deposit now
            </button>

            <span className='text-2xs uppercase tracking-[0.18em] text-white/35'>Card or crypto · quick top-up</span>
        </Panel>
    )
}
